<template>
	<div class="set-no-keywords">
		<el-form ref="form" :model="form" :rules="formRules" label-width="80px">
			<el-form-item label="间隔时间" prop="time">
				<el-select v-model="form.timeUnit" style="width: 100px;margin-right: 5px;" size="mini">
				    <el-option label="秒" value="s"></el-option>
				    <el-option label="分" value="m"></el-option>
					<el-option label="时" value="h"></el-option>
				</el-select>
				<el-input-number v-model="form.time"  :min="1" size="mini"></el-input-number>
			</el-form-item>
			<el-form-item v-for="(item, index) in form.contents" label="回复内容" :key="'contents.' + index"
				:prop="'contents.' + index + '.response'" :rules="{
			      required: true, message: '请输入回复内容', trigger: 'blur'
			    }">
				<el-select v-model="item.responseType" placeholder="请选择" style="width: 100px;" size="mini">
					<el-option label="文本" value="text"></el-option>
					<!-- <el-option label="IM" value="im"></el-option> -->
				</el-select>
				<el-input size="mini" placeholder="请输入回复内容" type="textarea" v-model="item.response" style="margin-top: 5px;" maxlength="300" show-word-limit>
				</el-input>
				<!-- <div style="display: inline-block;margin-left: 5px;">
					<el-button type="text" @click.prevent="addContents(item,index)" v-show="active_contents == index">添加</el-button>
					<el-button type="text" @click.prevent="removeContents(item,index)" v-show="form.contents.length > 1">删除</el-button>
				</div> -->
			</el-form-item>
			  <el-form-item style="text-align: right;">
				  <el-popconfirm title="确定要删除规则吗？"  @confirm="onDelete">
					<el-button size="mini" slot="reference" style="margin-right: 20px;" v-show="form.id">删除</el-button>
				  </el-popconfirm>
				
			    <el-button type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }} </el-button>
			  </el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['row_item'],
		inject:['row_data'],
		data(){
			return {
				loading:false,
				form:{
					time:'',
					timeUnit:'s',
					id:'',
					contents:[
						{
							response:'',
							responseType:'text',
							orderno: 0,
							key: new Date().getTime()
						}
					]
				},
				formRules:{
					time: [{
						required: true,
						message: '请输入时间间隔',
						trigger: 'change'
					}]
				}
			}
		},
		watch:{
			row_item(val){
				this.getList();
			}
		},
		methods:{
			onSave(){
				this.$refs.form.validate((valid) => {
					if(valid) {
						this.loading = true;
						if(this.form.id){
							this.$api.editWechatSystemNoKeywords({
								appid: this.row_data.data.appid || this.row_data.data.id,
								rulesKeyList:this.formatKey(),
								rulesResponseList:this.form.contents,
								id:this.form.id
							}).then(res => {
								this.loading = false;
								this.$message.success('编辑成功');
								this.getList()
							})
						}else {
							this.$api.addWechatSystemNoKeywords({
								appid: this.row_data.data.appid || this.row_data.data.id,
								rulesKeyList:this.formatKey(),
								rulesResponseList:this.form.contents,
							}).then(res => {
								this.loading = false;
								this.$message.success('添加成功');
								this.getList()
							})
						}
					}
				})
			},
			formatKey(){
				let result = [];
				result.push({
					keysValue: this.form.time + this.form.timeUnit,
					matchType: "3",
					orderno: 0,
					timeUnit:this.form.timeUnit,
					timeValue:this.form.time 
				})
				return result
			},
			onDelete(){
				this.$api.deleteWechatSystemNoKeywords({id:this.form.id}).then(res => {
					this.$message.success('删除成功');
					this.getList()
				})
			},
			getList(){
				let params = {
					 data: {
					    appid: this.row_item.appid || this.row_item.id,
					  },
					  pageNum:1,
					  pageSize: 10,
				}
				this.$api.getWechatSystemNoKeywords(params).then(res => {
						if(res.errcode == 0){
							if(res.list.length > 0) {
								let result = res.list[0];
								this.form.contents = result.rulesResponseList;
								this.form.id = result.id;
								const timeOriginal = result.rulesKeyList[0].keysValue;
								this.form.time = timeOriginal.substring(0, timeOriginal.length - 1);
								this.form.timeUnit = timeOriginal.substring(timeOriginal.length - 1);
							}else {
								this.form = {
									time:'',
									timeUnit:'s',
									id:'',
									contents:[
										{
											response:'',
											responseType:'text',
											orderno: 0,
											key: new Date().getTime()
										}
									]
								}
							}
						}
				})
			}
		},
		async mounted() {
			await this.getList()
		}
	}
</script>

<style lang="scss" scoped>
	.set-no-keywords {
		padding: 20px 0;
	}
</style>
